class Step {
  constructor({ stepSlug, stepDefinition }) {
    this.stepSlug = stepSlug;
    this.stepDef = stepDefinition;
  }

  slug() {
    return this.stepSlug;
  }

  validate(defField) {
    if (defField in this.stepDef === false) {
      throw Error(`Badly defined step definition. Missing ${defField}`);
    }
  }

  type() {
    if ('type' in this.stepDef === false) {
      return '';
    }
    return this.stepDef.type;
  }

  name() {
    this.validate('name');
    return this.stepDef.name;
  }

  descriptionMdBlocks() {
    this.validate('descriptionMdBlocks');
    return this.stepDef.descriptionMdBlocks;
  }

  nextSteps() {
    this.validate('nextSteps');
    return this.stepDef.nextSteps;
  }

  images() {
    this.validate('images');
    return this.stepDef.images;
  }
}

export default Step;
